module.exports = __webpack_public_path__ + "assets/bay_area@2x.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./assets/bay_area@2x.jpg
 ** module id = 203
 ** module chunks = 1
 **/